<template lang="pug">
transition-group.root(
  :tag="tag"
  name="shuffle"
  @before-enter="before"
  @before-leave="before"
  @after-enter="after"
  @after-leave="after")
  slot
</template>

<script>
export default {
  name: "Shuffle",
  props: {
    tag: {
      type: String
    },
    enforceWidth : {
      type: Boolean,
      default: false
    }
  },
  methods: {
    before(el) {
      if (!this.enforceWidth) return;
      const width = this.$el.firstElementChild.offsetWidth;
      el.style.width = `${width}px`;
    },
    after(el) {
      if (!this.enforceWidth) return;
      el.style.width = ''
    } 
  }
};
</script>

<style scoped lang="scss">
.root {
  position: relative;
  &::v-deep {
    .shuffle-leave-active,
    .shuffle-enter-active {
      transition: all 350ms ease;
    }

    .shuffle-enter {
      opacity: 0;
      transform: translateY(30px);
    }

    .shuffle-leave-to {
      opacity: 0;
      transform: translateY(30px);
    }

    .shuffle-leave-active {
      position: absolute;
    }
  }
}
</style>
